import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Formik, ErrorMessage, Form, Field } from 'formik'
import { submitFahrer, fetchOneUserByUsername, fetchOneUserByAuth } from '../../actions'

const inputStyle = {
  marginBottom: '10px'
}

class FahrerNew extends Component {

  constructor(props) {
    super(props);

    this.state = {
      rtvalue: ''
    }
    this.cancelLink = this.cancelLink.bind(this);
    //this.dataThere = this.dataThere.bind(this);
  }

  componentDidMount() {
    this.props.fetchOneUserByAuth();
  }

  cancelLink() {
    var cancelPath = '/';
    if (this.props.auth) {
      cancelPath = '/fahrer';
    }
    return cancelPath;
  }

  isAdmin() {
    if (!this.props.auth) {
      return false;
    }
    if (this.props.auth.roles.indexOf('admin')>-1) {
      return true;
    } else {
      return false;
    }
  }

  render() {

    var initValues = {};

    if (initValues) {
      if (!initValues.email) {
        initValues.email = '';
      }
    }

    //const auth = this.props.auth;

    return (
      <div>

        <h4 style={{fontStyle:'italic'}}>Teilnehmer/in hinzufügen</h4>

        <Formik
          initialValues={initValues}
          validate={values => {
            let errors = {};
            if (!values.email) {
              errors.email = 'Die Mailadresse ist erforderlich.';
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
              errors.email = 'Keine gültige Email-Adresse';
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            console.log("submitting FahrerNew");
              setSubmitting(true);
              this.props.submitFahrer( values, this.props.history );
              setSubmitting(false);
          }}
        >

          {({ isSubmitting, props, setFieldValue, initValues, values, setSubmitting }) => (

            <Form
              onKeyPress={e =>{
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}>
              <label htmlFor="email">Email</label>
              <Field name="email" style={inputStyle} />
              <ErrorMessage name="email" component="div" />
                <Link to={this.cancelLink()} style={{marginRight: '10px'}} type="cancel">
                  <button className="btn btn-secondary" >
                  <span style={{color: 'white'}}>Abbrechen</span>
                  </button>
                </Link>
              <button className="btn btn-default" type="submit" disabled={isSubmitting}>
                Absenden
              </button>
            </Form>
          )}
        </Formik>
        <div style={{height: "80px"}}></div>
      </div>
    )}
}

const mapDispatchToProps = {
  fetchOneUserByUsername,
  fetchOneUserByAuth,
  submitFahrer
}

function mapStateToProps({ auth, singleUser }) {
	return { auth, singleUser }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(FahrerNew);



// WEBPACK FOOTER //
// ./src/components/fahrer/FahrerNew.js